var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 2.19418e-06C21.582 -0.00172813 17.7316 1.01996 14.3299 2.96391C10.9282 4.90786 8.09326 7.70663 6.10582 11.0831C4.11837 14.4596 3.04735 18.2966 2.99879 22.2143C2.95024 26.1319 3.92584 29.9943 5.829 33.419L0 48L14.581 42.168C17.5845 43.8368 20.9303 44.7956 24.3618 44.9707C27.7933 45.1459 31.2194 44.5329 34.3772 43.1786C37.535 41.8243 40.3407 39.7648 42.5792 37.158C44.8176 34.5512 46.4292 31.4664 47.2906 28.1401C48.1519 24.8139 48.2399 21.3345 47.548 17.9689C46.856 14.6034 45.4025 11.441 43.2988 8.72427C41.1951 6.00758 38.4972 3.80878 35.4119 2.2965C32.3266 0.784221 28.936 -0.00136187 25.5 2.19418e-06ZM25.5 42C22.1899 41.9984 18.9347 41.1542 16.041 39.547L14.793 38.854L13.468 39.382L5.384 42.613L8.616 34.53L9.147 33.205L8.454 31.957C6.38049 28.2164 5.59469 23.8976 6.2177 19.6663C6.84072 15.435 8.83796 11.5261 11.9016 8.54183C14.9653 5.55758 18.9254 3.66368 23.1716 3.15201C27.4178 2.64034 31.7144 3.53929 35.3993 5.71033C39.0842 7.88136 41.9528 11.204 43.5632 15.1661C45.1735 19.1283 45.4361 23.5101 44.3106 27.6362C43.1851 31.7624 40.7338 35.4038 37.3346 37.9995C33.9354 40.5951 29.7769 42.0008 25.5 42Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-bubble.c828d491fd52d41f89207c28225921a9.svg";